import { TimerTopBar } from '../../shared/TimerTopBar'

export const Header = () => {
	return (
		<TimerTopBar
			center={
				<div className='flex h-12 min-w-0 translate-y-[3px] items-center whitespace-nowrap text-center text-[22px] font-bold leading-none text-black'>
					Табата Таймер
				</div>
			}
		/>
	)
}
